import { EntityColorMapInput } from '@dealstack/frontend/shared/lib/BlockTable/BlockEntityCell/BlockEntities.types.ts';
import { BlockEntitiesRow } from '@dealstack/frontend/shared/lib/BlockTable/BlockEntityCell/BlockEntitiesRow.tsx';
import { Text } from '@mantine/core';
import type { BlockEntityEvent } from './BlockEntitiesTable.types';
import { Body, Header, HeaderCell, TableContainer } from './styled';

interface Props {
	headers: { label: string; color: string }[];
	events: Array<BlockEntityEvent>;
	issuerEntityId: string;
	mainEntityId: string;
	entityColorMap: EntityColorMapInput;
}

export const BlockEntitiesTable = ({
	headers,
	events,
	issuerEntityId,
	mainEntityId,
	entityColorMap,
}: Props) => (
	<TableContainer>
		<Header>
			{headers.map((hdr, index) => (
				<HeaderCell key={`${hdr.label}-${index}`} bgColor={hdr.color}>
					<Text fw={600} ml="-100%">
						{hdr.label}
					</Text>
				</HeaderCell>
			))}
		</Header>
		<Body>
			{events.map((tx, index) => (
				<BlockEntitiesRow
					key={`${tx.id}-${index}`}
					issuerEntityId={issuerEntityId}
					mainEntityId={mainEntityId}
					transactionType={tx.transactionType}
					fromEntityId={tx.fromEntityId}
					toEntityId={tx.toEntityId}
					fromEntityName={tx.fromEntityName}
					toEntityName={tx.toEntityName}
					blocks={tx.blocks}
					fromBlocksHeld={tx.fromBlocksHeld}
					toBlocksHeld={tx.toBlocksHeld}
					date={tx.date}
					units={tx.units}
					entityColorMap={entityColorMap}
					currency={tx.currency}
					fromCost={tx.fromCost}
					toCost={tx.toCost}
					securityIssuedIn={tx.securityIssuedIn}
					transactionCost={tx.transactionCost}
					securityUnitDenominator={tx.securityUnitDenominator}
				/>
			))}
		</Body>
	</TableContainer>
);
